import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';

@Injectable()
export class FileUploadService {
    /**
     * @param Observable<number>
     */
    private readonly progress$: Observable<number>;

    /**
     * @type {number}
     */
    private progress = 0;

    private progressObserver: any;

    public file: any[] = [];

    /**
     * Set interval for frequency with which Observable inside Promise will share data with subscribers.
     *
     * @param interval
     */
    private static setUploadUpdateInterval (interval: number): void {
        setInterval(() => {}, interval);
    }

    constructor (
        private config: AppConfig
    ) {
        this.progress$ = new Observable((observer: any) => {
            this.progressObserver = observer;
        });
    }

    /**
     * @returns {Observable<number>}
     */
    public getObserver (): Observable<number> {
        return this.progress$;
    }

    /**
     * Upload files through XMLHttpRequest
     *
     * @param url
     * @param files
     * @param params
     * @returns {Promise<any>}
     */
    public upload (url: string, files: File[], params: any): Promise<any> {
        return new Promise((resolve, reject) => {
            const formData: FormData = new FormData(),
                xhr: XMLHttpRequest = new XMLHttpRequest();

            if (params) {
                for (const item in params) {
                    if (params.hasOwnProperty(item)) {
                        formData.append(item, params[item]);
                    }
                }
            }

            for (let i = 0; i < files.length; i++) {
                formData.append('uploads[]', files[i], files[i].name);
            }

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            FileUploadService.setUploadUpdateInterval(200);

            xhr.upload.onprogress = (event) => {
                this.progress = Math.round(event.loaded / event.total * 100);

                this.progressObserver.next(this.progress);
            };

            xhr.open('POST', url, true);
            xhr.send(formData);
        });
    }

    public fileInputHandler (fileInput: any) {
        const FileList: FileList = fileInput.target.files;
  
        for (let i = 0, length = FileList.length; i < length; i++) {
            this.file = [FileList.item(i)];
        }

        return this.file;
    }

    public uploadHandler(tipusDocument, userId): Promise<any> {
        return new Promise((resolve, reject) => {
            try {
                const ruta = this.config.apiUrl + this.config.uploadRoute;
    
                const params = <any>{
                    'accio': 'WsUploadDoc',
                    'tipus_document': tipusDocument,
                    'userId': userId,
                };
    
                this.upload(ruta, this.file, params)
                  .then(response => {
                    if (response.status > 200) {
                        response.error = 'Error al pujar l\'arxiu. Comprova que l\'arxiu pujat compleixi els requisits.';
                        reject(response);
                    } else if (response.status === '109') {
                        response.error = 'Heu superat el màxim de fitxers per a aquest tipus de document.';
                        reject(response);
                    } else {
                        response.success = 'Arxiu pujat correctament.';
                        resolve(response);
                    }
                  })
                  .catch(error => {
                      const errorResponse = {
                          error: 'Error al pujar l\'arxiu: ' + error
                      };
                      reject(errorResponse);
                  });
            } catch (error) {
                const errorResponse = {
                    error: 'Error al pujar l\'arxiu: ' + error
                };
                reject(errorResponse);
            }
        });
    }
    
}
